import styled from 'styled-components';
import tw from 'twin.macro';
import UICard from '../../styled components/UICard';
import { Body, Meta } from '../../styled components/Typography';

export const WidgetsList = styled.ul(() => [tw`mt-16 space-y-8`]);

export const WidgetsListItem = styled.li(() => []);

export const WidgetsListItemCard = styled(UICard).attrs(() => ({
  $padding: 4,
  as: 'a'
}))(() => [tw`transition opacity-100 active:opacity-50 cursor-pointer`]);

export const NoWidgetsContainer = styled.div(() => [tw`text-center mt-48 mb-48`]);
export const NoWidgetsTitle = styled(Body).attrs(() => ({
  as: 'p',
  $textStyle: 'italic'
}))(() => [tw`text-blue-base text-opacity-95`]);
export const NoWidgetsText = styled(Meta).attrs(() => ({
  as: 'p'
}))(() => [tw`mt-8`]);
